import React from "react";
import { makeStyles } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    root: {
        width: 220,
        textAlign: 'center'
    },
    gridIcons: {
        width: 100,
        height: 100,
        borderRadius: '50%',
        margin: 'auto',
        background: "rgba(230,0,1,0.1)",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },

    icons: {
        width: "35%",
        // height: 36,
    },
    title: {
        fontSize: 16,
        margin: '20px auto'
    },
    gridbtn: {
        width: '100%',
        backgroundColor: '#EAEAFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 38,
        height: 60,
        marginBottom: 50,
        cursor: 'pointer'
    },
    btns: {
        margin: 0,
        color: '#182551',
        fontSize: 16,
        marginRight: 5
    },
}))

export default function Index({ data }) {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridIcons']}>
                <img src={data?.icon} alt="" className={classes['icons']} />
            </div>
            <div>
                <h3 className={classes['title']}>
                    {data?.title}
                </h3>
            </div>
            <a href={data?.link} download>
                <div className={classes['gridbtn']}>
                    <p className={classes['btns']}>
                        دانلود
                    </p>
                </div>
            </a>
        </div>)
}
